<!--
 * @Author: xionglinlin
 * @LastEditTime: 2023-09-25 11:00:00
 * @Description: 组态管理
-->
<template>
  <div
    class="absolute w-468px right-25px"
    :style="{
      height: location.height,
      top: location.top,
      right: location.float === 'right' ? '25px' : '',
      left: location.float === 'left' ? '25px' : '',
    }"
  >
    <el-card class="state-mgt text-white p-10px h-1/2 z-99">
      <div slot="header" class="flex justify-between items-center">
        <span class="text-14px">组态管理</span>
        <div class="flex items-center">
          <el-tooltip content="导出" :open-delay="1000" effect="light">
            <el-button
              type="success"
              class="iconfont icon-line-download"
              @click="exportExcel(0)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="导入组态" :open-delay="1000" effect="light">
            <el-button
              type="success"
              class="iconfont icon-line-upload"
              @click="uploadExcel(0)"
            ></el-button>
          </el-tooltip>
          <el-dropdown class="ml-10px">
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreHorizontal font-bold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
              <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span
            class="ml-20px iconfont icon-line-close float-right cursor-pointer text-12px"
            @click="closeComponent"
          ></span>
        </div>
      </div>
      <div class="flex h-38px p-5px mt-5px mb-5px">
        <el-input
          class="w-1/2 mr-10px"
          placeholder="搜索名称"
          v-model="keyWord"
          clearable
          @keyup.enter.native="getTreeData"
        ></el-input>
        <el-button type="primary" size="mini" @click="getTreeData" class="!h-36px">搜索</el-button>
        <el-button type="primary" size="mini" class="!h-36px" @click="handleTreeData('create')"
          >新增</el-button
        >
      </div>
      <div class="h-[calc(100%-45px)] p-5px">
        <el-tree
          v-if="treeStandBy"
          ref="tree"
          :data="treeData"
          node-key="id"
          :props="{
            children: 'children',
            label: 'name',
          }"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :default-expanded-keys="defaultExpandIds"
          :default-expand-all="defaultExpandAll"
          :current-node-key="currentSelectKey"
          v-loading="treeLoading"
        >
          <div
            class="custom-tree-node overflow-hidden w-full flex justify-between items-center"
            slot-scope="{ node, data }"
          >
            <el-tooltip effect="light" :open-delay="400" :content="node.label" placement="top">
              <span class="text-sm flex-1 mr-10px truncate">{{ data.name }}</span>
            </el-tooltip>
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="iconfont icon-line-moreVertical text-white"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleTreeData('create', data)"
                  >新增</el-dropdown-item
                >
                <el-dropdown-item @click.native="handleTreeData('edit', data)"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item @click.native="removeTreeData(data)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-tree>
      </div>
    </el-card>
    <div class="h-1/2 mt-2px state-mgt z-99">
      <el-card class="text-white p-10px !pb-0px h-[calc(100%-50px)]">
        <div slot="header" class="flex items-center h-30px">
          <span class="text-14px mr-50px">组态对象管理</span>
          <el-form :rules="switchRules" :show-message="false" :validate-on-rule-change="false">
            <el-form-item label="组态对象隐藏" prop="switch" label-width="98px" class="!mb-0">
              <el-switch v-model="objectShow" @change="showModels" class="-mt-5px"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          v-loading="tableloading"
          :data="tableData"
          highlight-current-row
          class="w-full"
          @row-click="rowClick"
          height="100%"
        >
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="modelName" label="模型名称"></el-table-column>
          <el-table-column prop="modelCode" label="模型编码"></el-table-column>
        </el-table>
      </el-card>
      <div class="h-50px flex justify-evenly items-center">
        <el-button type="primary" class="iconfont icon-line-show" size="mini" @click="preview">
          <span class="ml-3px" v-if="isPreview">预览</span>
          <span class="ml-3px" v-else>取消</span>
        </el-button>
        <el-button
          type="success"
          class="iconfont icon-line-download"
          size="mini"
          @click="exportExcel(1)"
        >
          <span class="ml-3px">导出</span>
        </el-button>
        <el-button
          type="success"
          class="iconfont icon-line-upload"
          size="mini"
          @click="uploadExcel(1)"
        >
          <span class="ml-3px">导入</span>
        </el-button>
        <el-button
          type="primary"
          class="iconfont icon-line-circleAdd"
          size="mini"
          @click="addDetail"
        >
          <span class="ml-3px">加入</span>
        </el-button>
        <el-button type="primary" class="iconfont icon-bg-close" size="mini" @click="deleteDetail">
          <span class="ml-3px">移除</span>
        </el-button>
      </div>
    </div>
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      :title="(treeOperateType === 'create' ? '新增' : '编辑') + '组态'"
      :visible.sync="treeDialog"
      v-dialogDrag
      @close="closeTreeForm"
      width="25%"
    >
      <el-form :model="treeForm" :rules="treeRules" ref="treeFormRef" label-width="80px">
        <el-form-item label="组态名称" prop="name">
          <el-input v-model="treeForm.name" size="small" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button type="primary" size="small" @click="saveTreeForm" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="closeTreeForm">取消</el-button>
      </div>
    </el-dialog>
    <wiz-upload-file
      v-dialogDrag
      @refreshList="refreshList"
      v-if="showUploadExcelDialog"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </div>
</template>
<script>
import { CompositeStateApi } from '@wiz-api/scene-management'
import { TempFileApi } from '@wiz-api/file-management'
import { isNil, isEmpty, get, forIn, find, map, flattenDeep } from 'lodash'
import FnMixins from '@/assets/js/fnMixins'
import cloudRender from '../../assets/js/model/index'

const compositeStateApi = new CompositeStateApi()
const tempFileApi = new TempFileApi()

export default {
  name: 'compositeState',
  mixins: [FnMixins],
  props: ['location', 'player', 'customProps'],
  data() {
    return {
      showUploadExcelDialog: false, // 导入组件显隐
      uploadType: null, // 0为组态， 1为组态明细
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
      },
      treeData: [], // 模型树数据
      treeLoading: false,
      defaultExpandAll: false, // 是否默认展开全部
      defaultExpandIds: [], // 默认展开
      treeStandBy: true, // 分类树显隐
      keyWord: '',
      treeDialog: false,
      treeForm: {
        name: '',
      },
      treeRules: {
        name: { required: true, message: '请输入组态名称', trigger: 'blur' },
      },
      treeOperateType: '',
      saveLoading: false,
      currentTreeData: null,
      selectTree: null, // 当前选中的节点数据
      currentSelectKey: null, // 当前选中节点id
      expandId: null, // 默认展开节点Id
      objectShow: false, // 组态对象隐藏
      switchRules: {
        switch: [{ required: true }],
      },
      tableData: [], // 组态对象管理表格
      tableloading: false,
      currentDetailId: '', // 选中组态对象id
      currentModel: {}, // 当前点选模型
      rootNode: '', // 当前根节点
      isPreview: true, // 预览取消否
    }
  },
  async created() {
    this.rootNode = await this.player.Native.NodeProxy.rootNode()
    this.player.Native.ModelTree.EventSelectItemChanged.connect(this.watchPickupMsg)
    const seletItem = await this.player.Native.ModelTree.getSelectedItem()
    if (isEmpty(this.currentModel) && seletItem) {
      this.currentModel = seletItem
    }
    if (this.customProps.currentNodeData) {
      this.currentModel = this.customProps.currentNodeData
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.getTreeData()
    })
  },

  beforeDestroy() {
    this.player.Native.ModelTree.EventSelectItemChanged.disconnect(this.watchPickupMsg)
  },

  computed: {
    loadModelType() {
      return currentEnv.loadModelType || 'documentId'
    },
    sceneId() {
      return this.$route.query.sceneId
    },
  },

  watch: {
    'customProps.currentNodeData': {
      async handler(val, oldVal) {
        if (val.nodePtr && val.nodePtr !== oldVal?.nodePtr) {
          this.currentModel.code = val.code
          this.currentModel.name = val.name
        }
      },
      deep: true,
    },
  },

  methods: {
    // 监听点选事件
    watchPickupMsg(data) {
      this.currentModel = data && data.item ? data : {}
    },

    // 下载导入模板
    async exportTemplate() {
      let [err, res] = [null, null]
      if (this.uploadType) {
        ;[err, res] = await compositeStateApi.getImportStepsTemplate() // 组态明细
      } else {
        ;[err, res] = await compositeStateApi.getImportCompositeStateTemplate()
      }
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: this.uploadType ? '组态明细导入模板.xlsx' : '组态导入模板.xlsx',
          data: res,
        })
      }
    },

    // 上传文件
    uploadExcel(type) {
      this.uploadType = type
      if (type && isEmpty(this.selectTree)) {
        this.$message.warning('请选择组态节点')
        return
      }
      this.showUploadExcelDialog = true
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },

    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      let [err, res] = [null, null]
      if (this.uploadType) {
        ;[err, res] = await compositeStateApi.importDetail(this.currentSelectKey, {
          file: formData.get('file'),
        })
      } else {
        ;[err, res] = await compositeStateApi.importCompositeState(this.sceneId, {
          file: formData.get('file'),
        })
      }
      if (!err) {
        this.uploadFileProps.active = 2
        this.uploadFileProps.successCount = res.successCount
        this.uploadFileProps.failureCount = res.failureCount
        // 如需兼容老样式，则resultFile字段为空或者不设置皆可
        this.uploadFileProps.resultFile = res.resultFile
      }
      this.uploadFileProps.btnLoading = false
    },

    // 导入后刷新列表
    refreshList() {
      if (this.uploadType) {
        this.getTreeDel(this.currentSelectKey)
      } else {
        this.getTreeData()
      }
    },

    // 导出文件
    async exportExcel(obj) {
      if (obj && isEmpty(this.selectTree)) {
        this.$message.warning('请选择组态节点')
        return
      }
      this.exportLoading = true
      let [err, res] = [null, null]
      if (obj) {
        ;[err, res] = await compositeStateApi.exportDet(this.currentSelectKey) // 组态明细
      } else {
        ;[err, res] = await compositeStateApi.callExport(this.sceneId)
      }
      this.exportLoading = false
      if (!err) {
        this.downLoadBlob({
          name: obj ? '组态明细列表.xlsx' : '组态列表.xlsx',
          data: res,
        })
      }
    },

    // 下载导入结果
    async exportResults() {
      const [err, res] = await tempFileApi.download(this.uploadFileProps.resultFile)
      if (!err) {
        this.downLoadBlob({
          name: this.uploadType ? '组态明细导入结果.xlsx' : '组态导入结果.xlsx',
          data: res,
        })
      }
    },

    // 收起、展开全部
    operateTree(bool) {
      if (!bool) {
        this.defaultExpandIds = []
      }
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },

    // 关闭弹窗
    closeComponent() {
      this.$emit('closeComponent', 'CompositeState')
      this.player.Native.NodeProxy.setNodeVisible(this.rootNode, true)
    },

    // 获取组态树
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await compositeStateApi.menuPageQueryList({
        keyWord: this.keyWord,
        isQueryAsTree: true,
        sceneId: this.sceneId,
      })
      if (!err && !isNil(res)) {
        this.treeData = res.items
        this.treeStandBy = false
        if (!isEmpty(this.defaultExpandIds)) {
          this.defaultExpandIds.push(this.currentSelectKey)
        }
        this.$nextTick(() => {
          this.treeStandBy = true
        })
      }
      this.treeLoading = false
    },

    // 组态树的增改操作
    async handleTreeData(type, data) {
      this.currentTreeData = data
      this.treeForm = this.$options.data().treeForm
      if (type === 'edit') {
        this.treeForm.name = data.name
      }
      this.treeOperateType = type
      this.treeDialog = true
    },

    // 保存组态操作（新增+编辑）
    saveTreeForm() {
      this.$refs.treeFormRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          // 新增
          if (this.treeOperateType === 'create') {
            const [err, res] = await compositeStateApi.create({
              body: {
                name: this.treeForm.name,
                parentId: isNil(this.currentTreeData) ? null : this.currentTreeData.id,
                sceneId: this.sceneId,
              },
            })
            if (!err && !isNil(res)) {
              this.$message.success({
                showClose: true,
                message: '新增组态成功',
              })
              if (res.parentId) {
                this.defaultExpandIds = [res.parentId]
              }
              await this.getTreeData()
            }
          } else {
            // 编辑
            const [err, res] = await compositeStateApi.update(this.currentTreeData.id, {
              body: {
                name: this.treeForm.name,
                parentId: this.currentTreeData.parentId,
                sceneId: this.sceneId,
              },
            })
            if (!err && !isNil(res)) {
              this.$message.success({
                showClose: true,
                message: '编辑组态成功',
              })
              if (res.parentId) {
                this.defaultExpandIds.push(res.parentId)
              }
              await this.getTreeData()
            }
          }
          this.saveLoading = false
          this.closeTreeForm()
        }
      })
    },

    // 关闭树节点操作弹框
    closeTreeForm() {
      this.treeDialog = false
      this.$refs.treeFormRef.resetFields()
    },

    // 删除树节点数据
    removeTreeData(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        lockScroll: false,
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await compositeStateApi.callDelete(data.id)
          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功！',
            })
            this.defaultExpandIds = [data.parentId]
            this.getTreeData()
            // 删除选中的数据
            if (this.currentSelectKey === data.id) {
              this.getTreeDel('')
              this.player.Native.NodeProxy.setNodeVisible(this.rootNode, true)
            }
          }
        })
        .catch(() => {})
    },

    // 获取组态详情
    async getTreeDel(id) {
      this.tableloading = true
      const [err, res] = await compositeStateApi.get(id)
      this.tableloading = false
      if (!err) {
        this.tableData = res.details
        this.objectShow = res.isHidden
      }
    },

    // 点击节点树
    async handleNodeClick(data) {
      await this.player.Native.NodeProxy.setNodeVisible(this.rootNode, true)
      this.isPreview = true
      this.selectTree = data
      this.currentSelectKey = data.id
      this.treeStandBy = false
      if (data.parentId) {
        this.defaultExpandIds = [data.parentId]
      }
      this.$nextTick(() => {
        this.treeStandBy = true
      })
      this.getTreeDel(this.currentSelectKey)
    },

    // 点击table当前行
    async rowClick(row) {
      this.currentDetailId = row.id
      const rowNodePtr = await this.player.Native.NodeProxy.findFirstNodeByName(
        this.rootNode,
        row.modelName
      )
      const aabb = await this.player.Native.NodeProxy.getAabb(rowNodePtr)
      const mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      this.player.Native.Camera.addMoveToAabb({ min: aabb[0], max: aabb[1] }, mat, 1, 1.8, 3)
      // 设置当前选中节点
      const nodeInfo = await this.player.Native.ModelTree.findItemByName(row.modelName, 0, true, 0)
      // 高亮模型
      this.player.Native.ModelTree.setSelectItem(nodeInfo.item)
    },

    // 移除组态对象
    async deleteDetail() {
      if (!this.currentDetailId) {
        return
      }
      const [err, res] = await compositeStateApi.deleteDetail({
        body: [this.currentDetailId],
      })
      if (!err) {
        this.$message.success('移除成功')
        this.currentDetailId = ''
        this.getTreeDel(this.currentSelectKey)
      }
    },

    // 加入组态对象
    async addDetail() {
      if (!this.currentSelectKey) {
        this.$message.warning('请选择组态节点')
        return
      }
      if (find(this.tableData, ['modelCode', this.currentModel.code])) {
        this.$message.warning('加入模型重复')
        return
      }
      if (isEmpty(this.currentModel)) {
        this.$message.warning('请选择模型')
        return
      }
      const [err, res] = await compositeStateApi.addDetail({
        body: {
          seqNo: 0,
          compositeStateId: this.currentSelectKey,
          modelCode: this.currentModel.name, // 需改为唯一标识
          modelName: this.currentModel.name,
        },
      })
      if (!err) {
        this.$message.success('加入成功')
        this.getTreeDel(this.currentSelectKey)
      }
    },

    // 组态对象隐藏
    async showModels(val) {
      if (!this.selectTree) return
      const [err, res] = await compositeStateApi.update(this.currentSelectKey, {
        body: {
          name: this.selectTree.name,
          parentId: this.selectTree.parentId || null,
          sceneId: this.sceneId,
          id: this.currentSelectKey,
          IsHidden: val,
        },
      })
      if (!err) {
        this.isPreview = true
        this.$message.success('保存成功')
      }
    },

    // 预览
    async preview() {
      // 取消按钮
      if (!this.isPreview) {
        this.player.Native.NodeProxy.setNodeVisible(this.rootNode, true)
        this.isPreview = !this.isPreview
        return
      }
      // 预览按钮
      const [err, hiddenObj] = await compositeStateApi.getNeedHiddenDetails(this.currentSelectKey)
      const arr = await Promise.all(
        map(hiddenObj, async (item) => {
          const info = await this.player.Native.NodeProxy.findNodeByName(
            this.rootNode,
            item.modelName
          )
          return info
        })
      )
      const nodePtr = flattenDeep(arr)
      // 只显示列表节点
      if (!this.objectShow) {
        this.player.Native.NodeProxy.setNodeVisible(this.rootNode, false)
      }

      for (let i = 0; i < nodePtr.length; i++) {
        this.player.Native.NodeProxy.setNodeVisible(nodePtr[i], !this.objectShow)
      }
      this.isPreview = !this.isPreview
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/style/index';

.state-mgt {
  background-color: rgba(0, 18, 55, 0.3) !important;
}

::v-deep {
  .el-card {
    &__body {
      padding: 0 !important;
      height: calc(100% - 25px);
      background-color: rgba(24, 41, 72, 0.5) !important;
      border-radius: 2px;
    }
  }

  .el-loading-mask {
    background-color: rgba(24, 41, 72, 0.8) !important;
  }

  .el-tree {
    height: 100% !important;
  }

  .el-card .el-card__header {
    background: transparent !important;
  }

  .el-button.el-tooltip {
    padding: 0 !important;
    width: 25px !important;
    height: 25px !important;
    line-height: 1 !important;
  }

  .el-table {
    background: transparent !important;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
  }
}
</style>
